import { render } from "./BotaoAcoes.vue?vue&type=template&id=684f66a3&scoped=true&ts=true"
import script from "./BotaoAcoes.vue?vue&type=script&lang=ts"
export * from "./BotaoAcoes.vue?vue&type=script&lang=ts"

import "./BotaoAcoes.vue?vue&type=style&index=0&id=684f66a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684f66a3"]])

export default __exports__